import React, { useEffect, useState, useRef, useCallback } from 'react';
import Footer from './Footer';
// import InitModal from './initModal';
// import { useScrollToTop } from '../hooks/ScrollTop';
import Loader from './Loader';
import 'venobox/dist/venobox.min.css';
import { useNavigate } from 'react-router-dom';
import '../../css/developer2.css';
import siteQueries from '../../queries/siteQueries';
import MainHeader from './MainHeader';
import { BookOpen, Search } from 'lucide-react';
import { BASE_URL } from '../../apis/api';
import RouteConstants from '../../constant/Routeconstant';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';
import { useScrollToTop } from '../../hooks/ScrollTop';

export default function SpeakersListSite() {
    const [isOpen, setIsOpen] = useState(false);
    const [speakers, setSpeakers] = useState([]);
    const [filterSpeakers, setFilterSpeakers] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState('');
    const [speakerFilter, setSpeakerFilter] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isFilterLoading, setIsFilterLoading] = useState(true);
    const pageSize = 20;
    
    const observer = useRef();
    const lastSpeakerElementRef = useCallback(node => {
        if (isLoadingMore) return;
        if (observer.current) observer.current.disconnect();
        
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setCurrentPage(prevPage => prevPage + 1);
                setIsLoadingMore(true);
            }
        });
        
        if (node) observer.current.observe(node);
    }, [isLoadingMore, hasMore]);

    const handleClose = () => setIsOpen(false);
    const handleOpen = () => setIsOpen(true);
    const navigate = useNavigate();
    
    const Speaker = siteQueries.useSpeakerListingMutation(
        async (response) => {
            const newSpeakers = response?.data?.items;
            if (currentPage === 0) {
                setSpeakers(newSpeakers);
            } else {
                setSpeakers(prev => [...prev, ...newSpeakers]);
            }
            setHasMore(response?.data?.totalPages > currentPage + 1);
            setIsLoading(false);
            setIsLoadingMore(false);
        },
    );

    const FilterSpeaker = siteQueries.useSpeakerlistforfilterMutation(
        async (response) => {
            setFilterSpeakers(response?.data);
            setIsFilterLoading(false);
        },
    );

    
    useEffect(() => {
        Speaker.mutateAsync({
            page: currentPage,
            size: pageSize,
            heading: selectedSpeaker
        });

        if (isFilterLoading) {
            FilterSpeaker.mutateAsync({
                page: 0,
                size: 1000,
                heading: ''
            });
        }
    }, [currentPage, selectedSpeaker, isFilterLoading]);

    // const handleSpeakerSelect = (speakerHeading) => {
    //     setSelectedSpeaker(speakerHeading);
    //     setIsDropdownOpen(false);
    //     setCurrentPage(0);
    //     setSpeakers([]);
    //     setHasMore(true);
    // };
    const handleSpeakerSelect = (speakerHeading) => {
        setSpeakers([]); 
        setCurrentPage(0);
        setHasMore(true); 
        setIsLoading(true); 
        
        setSelectedSpeaker(speakerHeading);
        setIsDropdownOpen(false);
         Speaker.mutateAsync({
            page: 0,
            size: pageSize,
            heading: speakerHeading
        });
    };

    const decodeHtml = (html) => {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    };

        const handleReadMore = (speaker) => {
            navigate(RouteConstants.SPEAKERVIEWILFK.replace(':id', speaker.id));
            };

    
    // useEffect(() => {
    //     document.title = `Speakers | Kerala Literature Festival 2025`;
    //     return () => {
    //         document.title = 'KLF 2025 | Kerala Lit Fest | Literature Festival | Literary Festival 2025';
    //     };
    // }, []);

    useScrollToTop();

    return (
         <div className="min-h-screen bg-slate-50 from-orange-50 via-white to-green-50">
           <MainHeader />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="min-h-[190px] flex justify-center items-center py-4 relative overflow-hidden" 
          style={{
                   backgroundImage: `url(${BannerBg})`,
                   backgroundSize: 'cover',
                   backgroundPosition: 'center',
                   backgroundRepeat: 'no-repeat',
               }}>
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400 text-[36px]">Speakers</span>
                            </h1>
                            <p className="text-white text-[15px] sm:text-[18px] mt-2 font-semibold opacity-90">
                                Stay updated with the latest from International Literature Festival of Kerala 2025
                            </p>
                        </div>
                    </div>

          <div className="container mx-auto px-4 py-8">
            <div className="flex justify-center">
              <div className="w-full max-w-md">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    className="block w-full pl-10 pr-4 py-3 text-base border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-orange-100 focus:border-orange-400 transition-all duration-200 bg-white shadow-md"
                    style={{ backgroundColor: 'white', height: '50px' }}
                    placeholder="Search speakers..."
                    value={speakerFilter}
                    onChange={(e) => {
                      setSpeakerFilter(e.target.value);
                      setIsDropdownOpen(true);
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                  />
                  {isDropdownOpen && (
                    <div
                      className="absolute z-50 w-full mt-2 bg-white rounded-xl shadow-2xl border border-gray-100"
                      style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        padding: '10px',
                        display: 'block',
                        position: 'absolute',
                        zIndex: 1000,
                      }}
                    >
                      <button
                        className={`w-full px-4 py-3 text-left rounded-lg transition-colors duration-150 font-medium ${
                          !selectedSpeaker ? 'bg-orange-100 text-orange-800' : 'text-gray-700 hover:bg-orange-50'
                        }`}
                        onClick={() => {
                          handleSpeakerSelect('');
                          setSpeakerFilter('');
                        }}
                      >
                        All Speakers
                      </button>
                      {filterSpeakers
                        .filter((speaker) =>
                          speaker.heading.toLowerCase().includes(speakerFilter.toLowerCase())
                        )
                        .map((speaker) => (
                          <button
                            key={speaker.id}
                            className={`w-full px-4 py-3 text-left rounded-lg transition-colors duration-150 ${
                              selectedSpeaker === speaker.heading ? 'bg-orange-100 text-orange-800' : 'text-gray-700 hover:bg-orange-50'
                            }`}
                            onClick={() => handleSpeakerSelect(speaker.heading)}
                          >
                            {speaker.heading}
                          </button>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="container mx-auto px-4 pb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 lg:gap-8">
              {speakers?.map((speaker, index) => (
                <div
                  ref={index === speakers.length - 1 ? lastSpeakerElementRef : null}
                  // onClick={() => handleReadMore(speaker)}
                  style={{ cursor: 'pointer' }}
                  className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100"
                  key={index}
                >
                  <div className="relative overflow-hidden">
                    <div className="aspect-square">
                      <img
                        src={`${BASE_URL}/${speaker?.photo}`}
                        alt={speaker?.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <BookOpen className="w-4 h-4 text-orange-600" />
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="text-lg font-bold text-gray-800 mb-2 group-hover:text-orange-600 transition-colors duration-200">
                      {speaker?.heading}
                    </div>
                    {/* <div className="text-sm text-gray-600 mb-3 font-medium">
                      {speaker?.name}
                    </div> */}
                    {/* <div
                        className="text-gray-600 text-sm leading-relaxed mb-4"
                        style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                        dangerouslySetInnerHTML={{
                            __html: decodeHtml(speaker?.content)
                        }}
                        /> */}

                        {/* <button 
                            onClick={() => handleReadMore(speaker)}
                            className="inline-flex items-center bg-[#efc847] hover:bg-[#f0872a87] text-black text-sm font-medium px-6 py-2 rounded-full transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                            >
                            Read More
                            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button> */}
                  </div>
                </div>
              ))}
            </div>
            {isLoadingMore && (
              <div className="text-center py-4">
                <Loader />
              </div>
            )}
          </div>

        </>
      )}
      <Footer handleOpen={handleOpen} />
    </div>
    );
}